var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShaon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.17 71.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7a14ad;}.cls-2{fill:#ff6ad4;opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.47,0a34.7,34.7,0,1,0,34.7,34.7A34.73,34.73,0,0,0,37.47,0Zm0,62.45A27.76,27.76,0,1,1,65.23,34.7,27.78,27.78,0,0,1,37.47,62.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.88,31.23H40.94V20.82a3.47,3.47,0,0,0-6.94,0V34.7a3.48,3.48,0,0,0,3.47,3.47H47.88a3.47,3.47,0,0,0,0-6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.39,37.18A34.7,34.7,0,1,0,34.7,71.88,34.73,34.73,0,0,0,69.39,37.18ZM34.7,64.94A27.76,27.76,0,1,1,62.45,37.18,27.79,27.79,0,0,1,34.7,64.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.1,33.71H38.17V23.3a3.47,3.47,0,1,0-6.94,0V37.18a3.47,3.47,0,0,0,3.47,3.47H45.1a3.47,3.47,0,0,0,0-6.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShaon);
export default __webpack_public_path__ + "static/media/shaon.1097246d10b7ba2365aff7c8902ef79e.svg";
export { ForwardRef as ReactComponent };